import React from "react";
import "./pages.css";
import OperationsLoop from "../components/operationsLoop";

function Operations({ handleLogout, deleteItem, user }) {
  return (
    <>
      <section className="mainSection">
        <nav className="hero">
          <h1 className="sr-only">Operations Page</h1>
          <button onClick={handleLogout}>Log Out</button>
        </nav>

        <main>
          <OperationsLoop deleteItem={deleteItem} user={user} />
        </main>
      </section>
    </>
  );
}

export default Operations;
